import apiInstance from "../Api/ApiInstance";

export async function Coupons(coupon) {
  return await apiInstance.get(`api/official-site/coupons/${coupon}`);
}
